import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import adminFormStyles from '../shared/styles/adminForm.styles';

const styles = {
  page: adminFormStyles.page,
  content: adminFormStyles.content,
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 2,
    justifyContent: 'space-between',
    mb: 3,
  },
  title: adminFormStyles.pageTitle,
  createButton: adminFormStyles.primaryButton,
};

export default function AlertsPage() {
  const navigate = useNavigate();

  return (
    <Box sx={styles.page}>
      <Box sx={styles.content}>
        <Stack sx={styles.header}>
          <Typography component="h1" sx={styles.title}>
            Alerts
          </Typography>
          <Button
            onClick={() => navigate('/alerts/new')}
            startIcon={<Add />}
            sx={styles.createButton}
            variant="contained"
          >
            Create new alert
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}
